import { RESELLER_GUIDE, RESELLER_PROG_TANDC } from "../config/constants";

//--done

const regTranslation = {
  en_US: {
    registration: {
      button: {
        Next: "Next",
        Previous: "Previous",
        Save_and_Exit: "Save and Exit",
        Submit: "Submit",
        //Rtrn_ChannelPrtn: 'Adobe Partner Connection',
        Helpdesk: "Contact Helpdesk",
      },
      stepList: {
        Region_and_Language: "Region & Language",
        Registration_Criteria: "Registration Criteria",
        Company_Info: "Company Info",
        Add_Contacts: "Add Contacts",
        Program_Agreements: "Program Agreement",
        //--Finish: 'Finish'
      },
      pageText: {
        region_lang: {
          heading: "Welcome",
          //--text: 'To get started, please select the location of your organization and your preferred language.'
        },
        reg_ctr: {
          heading: "Welcome",

          //--heading_1: 'Criteria :',
          //-text_1: 'Thank you for your interest in the Adobe Partner Connection Reseller Program. Your path to membership begins with this online enrolment process.',
          //-text_2: 'Please review the Reseller Program requirements for your desired level and the registration criteria below. When you are ready to proceed, confirm that you are authorised to complete this application. Then click <b>Next</b> to continue.',
          //text_3: 'Reseller must meet all of the criteria for the desired level. See the <a class="adobeblue" href="' + RESELLER_GUIDE + '" target="_blank">Adobe Partner Connection Reseller Program Guide</a> for a complete list of requirements.',
          //text_4: 'Reseller must complete this online enrolment and accept the <a class="adobeblue" href="' + RESELLER_PROG_TANDC + '" target="_blank">Reseller Program terms and conditions</a>.',
          //-text_5: 'an officer or director of the company or',
          //-text_6: 'a person expressly authorised by an officer or director to complete this application on behalf of the company.'
        },
        company_info: {
          heading: "Tell us about your organization.",
          text_1:
            "Please provide the following information about your organization. If you'd like to continue this at a later time, you can save your progress and exit using the button at the bottom of the form",
          heading_1: "Your data has been saved.",
          text_2:
            "Please feel free to return when you are ready to complete the enrollment.",
          basic_info: "Basic Company Info",
          location: "Location",
          contact_info: "Contact Info",
        },
        add_conts: {
          //--heading: 'Contact information',
          //--text_1: 'Please provide the contact information for your organisation. Primary and secondary contacts are required. You may add additional contacts so we can contact you for sales, marketing, and technical updates.',
          primary_contact: "Primary Contact (you) *",
          secondary_contact: "Secondary Contact",
          additional_contact: "Additional Contacts",
        },
        prog_agmt: {
          //--heading: 'Terms & Conditions',
          text_1:
            "We're almost done. The last step is to read the Patner Connection Program reseller agreement. Confirm your acceptance when indicated.",
        },
        finish: {
          //heading: 'Thank you!',
          //--text_1: 'Thanks for your interest in the Adobe Partner Connection Reseller Program. We have received your application. You will receive a confirmation e-mail shortly. We will continue to notify you via e-mail of any updates regarding your application.',
          //text_2: 'If you need assistanace, please contact the Adobe Patner Connection Help Desk.'
        },
      },
      labels: {
        region_lang_region: "Region",
        //--region_lang_country: 'Country',
        //--region_lang_language: 'Language',
        //--company_name: 'Company Name *',
        biz_reg_number: "Business Registration Number",
        year_established: "Year Established *",
        trading_name: "Trading Name",
        distributor: "Preferred Distributor",
        company_type: "Company Type(select all that apply) *",
        street: "Street *",
        state: "State/Province *",
        country: "Country *",
        city: "City *",
        postal_code: "Postal Code *",
        primary_phone: "Primary Phone *",
        comp_email_address: "Company E-mail Address *",
        sec_website: "Secondary Website",
        fax: "Fax",
        url: "Website URL *",
        prefix: "Prefix",
        title: "Suffix/Title",
        first_name: "First Name *",
        last_name: "Last Name *",
        pref_language: "Preferred Language *",
        phone_number: "Phone Number *",
        email_address: "E-mail Address *",
        job_role: "Job Role *",
        contact_type: "Contact Type(select all that apply) *",
      },

      OnbrdContactPrefLang: "Preferred Language *",
      ONBLangPref: "Region & Language",
      OnbrdCriteriaHeader: "Registration Criteria",
      ONBCompInfo: "Company Info",
      ONBContsInfo: "Contact Info",
      ONBPgmAgreement: "Program Agreement",
      OnbrdProfileRegion: "Region *",
      //not needed "OnbrdGenSelectErrorMsg": "Please select a value.",
      OnbrdProfileCountry: "Country *",
      //not needed "OnbrdCriteriaSectionHeader": "REGISTRATION CRITERIA",
      OnbrdCriteriaAuthorized: "an officer or director of the company or",
      OnbrdCriteriaAuthorized1:
        "a person expressly authorised by an officer or director to complete this application on behalf of the company.",
      //not needed "ONBEnterCompDetails": "Please provide the following information about your organization.",
      OnbrdProfileFullCompName: "Company Name *",
      OnbrdProfileTradingName: "Trading Name",
      OnbrdProfileBRN: "Business Registration Number *",
      OnbrdProfilePreferredDistributor: "Preferred Distributor",
      OnbrdProfileYrIncorp: "Year Established *",
      OnbrdProfileStreet: "Street *",
      OnbrdProfileCity: "City *",
      OnbrdProfileState: "State/Province *",
      OnbrdProfilePostCode: "Postal Code *",
      OnbrdProfilePrimPhone: "Primary Phone *",
      OnbrdProfilePrimFax: "Primary Fax",
      OnbrdProfileContactEmail: "Email Address *",
      OnbrdProfilePrimURL: "Website *",
      OnbrdProfileSecondaryURL: "Secondary Website",
      OnbrdContactSecContactInfo: "Contact information",
      ReAssignContactNameLabel: "NAME",
      //not needed "ConsolePartnerContactCType": "Main Contact Type",
      //"OnbrdContactPrimaryType": "Primary",
      //"OnbrdContactSecondaryType": "Secondary",
      //"OnbrdContactOtherType": "Other",
      ConsolePartnerBtnEdit: "Edit",
      QBPDelete: "Delete",
      OnbrdContactPriConHeader: "Primary Contact (you) *",
      OnbrdContactSecConHeader: "Secondary Contact *",
      //"OnbrdContactOther": "Other Contacts",
      OnbrdContactPrefix: "Prefix",
      OnbrdContactTitle: "Suffix/Title",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "First Name *",
      OnbrdContactLName: "Last Name *",
      OnbrdContactPhone: "Phone Number *",
      OnbrdContactJRole: "Job Role *",
      job_role_ws: "ROLE",
      OnbrdContactEmail: "Email *",
      OnbrdContactAddtlType: "Type *",
      TrngSaveClose: "Save and Close",
      TrngClose: "Close",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactFName: "FIRST NAME",
      OnbrdCertContactLName: "LAST NAME",
      OnbrdCertContactEmail: "EMAIL",
      //"ONBCerContactDetails": "Certified Contact details",
      //"OnbrdThankYouRenewalRegistered": "Your renewal has been filed and you will receive a confirmation email shortly.",
      Previous: "Previous",
      "Save and Exit": "Save and Exit",
      Submit: "Submit",
      Next: "Next",

      Welcome: "Welcome",
      Add_Contacts: "Add Contacts",
      add: "Add",
      Select: "Select",
      select_all_that_apply: "Select all that apply",
      i_certify: "I certify that I am either:",
      tell_us: "Tell us about your organization.",
      comp_info_text:
        "Please provide the following information about your organization. If you’d like to continue this at a later time, you can save your progress and exit using the button at the bottom of the form.",
      msg_saving_data: "Saving your form data",
      msg_data_saved: "Your data has been saved.",
      msg_verifing_address: "Verifying Address",
      basic_comp_info: "Basic Company Info",
      location: "Location",
      comp_email_address: "Company E-mail Address *",
      save_n_exit_body:
        "Feel free to return when you're ready to complete the enrollment process. You'll be returned to right were you left off. You can now close this browser window or navigate to another website.",
      contact_type: "Contact Type(select all that apply) *",
      OnbrdProfileCompType: "Company Type(select all that apply) * ",
      additional_contacts: "Additional Contacts",
      add_additional_contacts: "Add additional contact",
      msg_add_contact_1:
        "Add details for an additional contact below. Then, when you're done, click Save.",
      confirm_deletion: "Confirm Deletion",
      delete_confirm_msg: "Are you sure you want to delete the contact :",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "We're almost done. The last step is to read the Partner Connection Program reseller agreement. Confirm your acceptance where indicated.",
      Register: "Register",
      "Contact Helpdesk": "Contact Helpdesk",

      prog_agmt_checkbox:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      //continue enrolement button tra is not there

      OnbrdContactSectionHeader:
        "Please provide the contact information for your organisation. Primary and secondary contacts are required. You may add additional contacts so we can contact you for sales, marketing, and technical updates.",
      ONBPreferredLanguage:
        "To get started, Please select the location of your organization and your preferred language.",
      OnbrdCriteriaBody:
        "Thanks for your interest in the Adobe Partner Connection Reseller Program. Your path to membership begins with this online enrolment process.",
      OnbrdCriteriaBody1:
        "Please review the Reseller Program requirements for your desired level and the registration criteria below. When you are ready to proceed, confirm that you are authorised to complete this application. Then click Next to continue.",
      OnbrdThankYouNewRegistered:
        "Thank you for your interest in the Adobe Partner Connection Reseller Program. We have received your application. You will receive a confirmation email shortly. We will continue to notify you via email of any updates regarding your application.",
      ONBRegCriteriaAgree:
        "Please review the registration criteria and indicate your acceptance.",
      OnbrdTermsSectionHeader: "Terms & Conditions",
      OnbrdThankYouHelpDesk:
        "If you need assistance, please contact the Adobe Partner Connection Help Desk.",

      "Continue Enrollment": "Continue Enrollment",
      thank_you: "Thank You!",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "Reseller must meet all of the criteria for the desired level. See the Adobe Partner Connection Reseller Program Guide for a complete list of requirements.",
      reg_ctr_text2:
        "Reseller must complete this online enrollment and accept the Reseller Program terms and conditions.",
      problem_header: "There was a problem.",
      sign_in: "Sign in with Adobe ID",
      associated_other_account:
        "The Adobe ID you've signed in with (%{email}) is already associated with another Adobe Partner program: %{program}. You can sign in with another Adobe ID, or you can contact the helpdesk to continue your registration.",
      account_not_found:
        "The Adobe ID you've signed in with (%{email}) does not match any current Adobe Partner Connection accounts. You can apply to join the Adobe Partner Connection program or sign in with a different Adobe ID.",
      OnbrdErrorUnauthorized:
        "Sorry, you are unauthorized to view the page. Please contact the Partner Help Desk for help with registering/upleveling.",
    },
  },

  fr_FR: {
    registration: {
      button: {
        Next: "Próximo",
        Previous: "Anterior",
        Save_and_Exit: "salvar e sair",
        Submit: "Submit",
        Rtrn_ChannelPrtn: "Adobe Partner Connection",
        Helpdesk: "Contact Helpdesk",
      },
      stepList: {
        Region_and_Language: "Região e idioma",
        Registrartion_Criteria: "Critérios de registro",
        Company_Info: "Informação da companhia",
        Add_Contacts: "Adicionar contatos",
        Program_Agreements: "Acordos de programa",
        Finish: "Terminar",
      },
      pageText: {},
      labels: {},

      OnbrdCriteriaAuthoriseMsg:
        "Confirmez que vous êtes autorisés à répondre à ce questionnaire au nom de votre organisation en activant la case à cocher à l'endroit indiqué.",
      OnbrdTermsPartnerCodeMsg:
        "Consultez les conditions générales et le code de conduite des partenaires commerciaux d'Adobe et confirmez votre acceptation en activant la case à cocher à l'endroit indiqué.",
      OnbrdContactPrefLang: "Langue choisie *",

      ONBLangPref: "Zone géographique et langue",
      OnbrdCriteriaHeader: "Critères d'adhésion",
      ONBCompInfo: "Informations sur la société",
      ONBContsInfo: "Coordonnées",
      ONBPgmAgreement: "Contrat du programme",
      OnbrdProfileRegion: "Région *",
      OnbrdGenSelectErrorMsg: "Veuille sélectionner une valeur.",
      OnbrdProfileCountry: "Pays *",
      OnbrdCriteriaSectionHeader: "Critères d'adhésion",
      OnbrdCriteriaAuthorized:
        "membre de la direction ou directeur de l’organisation",
      OnbrdCriteriaAuthorized1:
        "une personne autorisée à répondre à ce questionnaire au nom de l’organisation",
      ONBEnterCompDetails:
        "Veuillez fournir les informations suivantes sur votre société.",
      OnbrdProfileFullCompName: "Nom complet de la société *",
      OnbrdProfileTradingName: "Raison commerciale",
      OnbrdProfileBRN: "Numéro SIRET *",
      OnbrdProfilePreferredDistributor: "Distributeur favori",
      OnbrdProfileYrIncorp: "Année de constitution de la société *",

      OnbrdProfileStreet: "Rue *",
      OnbrdProfileCity: "Ville *",
      OnbrdProfileState: "État/Province *",
      OnbrdProfilePostCode: "Code postal *",
      OnbrdProfilePrimPhone: "Num.Téléphone Principal *",
      OnbrdProfilePrimFax: "Num.Fax Principal",
      OnbrdProfileContactEmail: "E-mail *",
      OnbrdProfilePrimURL: "Site web *",
      OnbrdProfileSecondaryURL: "Site web secondaire",
      OnbrdProfileListPartnerFinder: "Figurer dans l'annuaire des revendeurs ?",
      OnbrdContactSecContactInfo: "Contacts",
      ReAssignContactNameLabel: "Nom du contact",
      ConsolePartnerContactEmail: "E-mail",
      ConsolePartnerContactCType: "Type du contact principal",
      OnbrdContactPrimaryType: "Principal",
      OnbrdContactSecondaryType: "Second",
      OnbrdContactOtherType: "Autres",
      ConsolePartnerBtnEdit: "Modifier",
      QBPDelete: "Supprimer",
      OnbrdContactPriConHeader: "Contact Principal *",
      OnbrdContactSecConHeader: "Contact Secondaire",
      OnbrdContactOther: "Autres contacts",
      OnbrdContactPrefix: "Préfixe",
      OnbrdContactTitle: "Suffixe/Titre",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Prénom *",
      OnbrdContactLName: "Nom *",
      OnbrdContactPhone: "Téléphoe *",
      OnbrdContactJRole: "Fonction *",
      job_role_ws: "Fonction",
      OnbrdContactEmail: "E-mail *",
      OnbrdContactAddtlType: "Type *",
      TrngSaveClose: "Enregistrer et fermer",
      TrngClose: "Fermer",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactFName: "Prénom",
      OnbrdCertContactLName: "Nom",
      OnbrdCertContactEmail: "E-mail",

      ONBCerContactDetails: "Détails du contact certifié",
      OnbrdThankYouRenewalRegistered:
        "Votre demande de renouvellement est enregistrée; vous recevrez très prochainement un e-mail de confirmation. Nous vous tiendrons régulièrement informé par e-mail de la suite donnée à votre dossier.",
      Previous: "Précédent",
      "Save and Exit": "Enregistrer et quitter",
      Submit: "Envoyer",
      Next: "Suivant",

      OnbrdContactSectionHeader:
        "REMARQUE : Vous devez spécifier des contacts principaux et secondaires. Vous pouvez ajouter d'autres contacts susceptibles de nous fournir des renseignements commerciaux, de marketing et techniques.",
      ONBPreferredLanguage:
        "Veuillez sélectionner le pays de votre entreprise et la langue de votre choix.",
      OnbrdCriteriaBody:
        "Nous vous remercions de l'intérêt que vous portez à Adobe Partner Connection Reseller Program. La procédure d'adhésion commence par cette inscription en ligne. ",
      OnbrdCriteriaBody1:
        "Veuillez consulter les conditions d'accès au niveau souhaité du Reseller Program et les critères d'adhésion ci-dessous. Vérifiez ensuite que vous êtes autorisés à répondre à ce questionnaire, puis cliquez sur Suivant.",
      OnbrdThankYouNewRegistered:
        "Nous vous remercions de l'intérêt que vous portez à Adobe Partner Connection. Nous avons bien reçu votre dossier de candidature. Vous recevrez très prochainement un e-mail de confirmation. Nous vous tiendrons régulièrement informé par e-mail de la suite donnée à votre dossier.",
      OnbrdThankYouHelpDesk:
        "Pour toute question sur Reseller Program ou votre candidature, contactez le service Adobe Partner Connection Help Desk",
      ONBRegCriteriaAgree:
        "Veuillez consulter les critères d'adhésion et confirmer votre accord.",
      OnbrdTermsSectionHeader: "Conditions générales",

      Welcome: "Bienvenue",
      Add_Contacts: "Ajouter des contacts",
      Select: "Sélectionner",
      add: "Ajouter",
      select_all_that_apply: "Plusieurs réponses possibles",
      i_certify: "Je certifie que je remplis l'une des conditions ci-dessous :",
      tell_us: "Parlez-nous de votre entreprise.",
      comp_info_text:
        "Veuillez fournir les informations suivantes sur votre société. Pour poursuivre le questionnaire ultérieurement, enregistrez vos réponses et fermez le formulaire à l’aide du bouton du bas.",
      msg_saving_data: "Enregistrement des données du formulaire",
      msg_data_saved: "Vos données sont enregistrées.",
      msg_verifing_address: "Vérification de l'adresse",
      basic_comp_info: "Informations générales sur l'entreprise",
      location: "Lieu",
      comp_email_address: "Adresse e-mail de l'entreprise *",
      save_n_exit_body:
        "Vous pouvez reprendre à tout moment le processus d'adhésion, exactement là où vous vous êtes arrêté. À présent, vous pouvez fermer la fenêtre de votre navigateur ou ouvrir un autre site web.",
      contact_type: "Type de contact (Plusieurs réponses possibles) *",
      OnbrdProfileCompType: "Type de société(Plusieurs réponses possibles) * ",
      additional_contacts: "Contacts supplémentaires",
      add_additional_contacts: "Ajouter un contact",
      msg_add_contact_1:
        "Ajoutez ci-dessous les coordonnées d'un autre contact. Une fois que vous avez terminé, cliquez sur Enregistrer.",
      confirm_deletion: "Confirmer la suppression",
      delete_confirm_msg:
        "Voulez-vous vraiment supprimer le contact suivant : ",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "Nous avons presque terminé. En dernier lieu, nous vous invitons à lire le contrat du programme Partner Connection. Suivez les indications à l'écran pour confirmer votre accord.",
      Register: "S’inscrire",
      "Contact Helpdesk": "Contacter l'assistance",

      "Continue Enrollment": "Continuer l'inscription",
      thank_you: "Merci.",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "Le partenaire doit remplir tous les critères requis pour le niveau demandé. Pour obtenir la liste complète de ces critères, consultez le Guide du programme Adobe Reseller Partner Connection.",
      reg_ctr_text2:
        "Le partenaire doit remplir ce formulaire d'inscription en ligne et accepter les Termes et Conditions générales du Reseller Program.",
      prog_agmt_checkbox:
        "J'AI LU, COMPRIS ET ACCEPTÉ L’ENSEMBLE DES CONDITIONS SUSVISÉES ET JE DÉCLARE ET GARANTIS QUE JE SUIS HABILITÉ À REPRESENTER MA SOCIETE.",
      problem_header: "Une erreur est survenue.",
      sign_in: "Connexion avec un Adobe ID",
      associated_other_account:
        "L'Adobe ID que vous avez saisi (%{email}) est déjà associé à un autre programme partenaire Adobe: %{program}. Connectez-vous avec un autre Adobe ID ou contactez notre assistance.",
      account_not_found:
        "L'Adobe ID que vous avez saisi (%{email}) ne correspond à aucun compte Adobe Partner Connection. Demandez à adhérer au programme Adobe Partner Connection ou connectez-vous avec un autre Adobe ID.",
      OnbrdErrorUnauthorized:
        "Désolé, vous n'êtes pas autorisé à consulter la page. Contactez le service d'assistance du programme en partenariat pour obtenir de l'aide sur le processus d'adhésion/de passage à un niveau supérieur.",
    },
  },

  pt_BR: {},

  zh_CN: {
    registration: {
      OnbrdContactPrefLang: "首选语言 *",
      ONBLangPref: "地区与语言",
      //"OnbrdCiteriaHeader": "注册标准",
      OnbrdCriteriaHeader: "注册标准",
      ONBCompInfo: "公司信息",
      ONBContsInfo: "联系信息",
      ONBPgmAgreement: "计划协议",
      OnbrdProfileRegion: "地区 *",
      OnbrdGenSelectErrorMsg: "请选择值。",
      OnbrdProfileCountry: "国家/地区 *",

      OnbrdCriteriaSectionHeader: "注册标准",
      OnbrdCriteriaAuthorized: "是公司的主管或总监，或者",
      OnbrdCriteriaAuthorized1:
        "得到主管或总监的明确授权，可以代表公司完成本次申请。",
      ONBEnterCompDetails: "请提供有关贵组织的以下信息。",
      OnbrdProfileFullCompName: "公司全称 *",
      OnbrdProfileTradingName: "中文公司名称",
      OnbrdProfileBRN: "商业注册号码 *",
      OnbrdProfilePreferredDistributor: "首选经销商",
      OnbrdProfileYrIncorp: "成立年份 *",
      OnbrdProfileStreet: "街道 *",
      OnbrdProfileCity: "城市 *",
      OnbrdProfileState: "州/省 *",
      OnbrdProfilePostCode: "邮政编码 *",
      OnbrdProfilePrimPhone: "首选电话 *",
      OnbrdProfilePrimFax: "首选传真",
      OnbrdProfileContactEmail: "电子邮件地址 *",
      OnbrdProfilePrimURL: "网站 *",
      OnbrdProfileSecondaryURL: "二级网站",
      OnbrdContactSecContactInfo: "联系信息",
      ReAssignContactNameLabel: "联系人姓名",
      ConsolePartnerContactEmail: "电子邮件",
      ConsolePartnerContactCType: "主要联系方式",
      OnbrdContactPrimaryType: "第一",
      OnbrdContactSecondaryType: "第二",
      OnbrdContactOtherType: "其它",
      ConsolePartnerBtnEdit: "编辑",
      QBPDelete: "删除",
      OnbrdContactPriConHeader: "第一联系人 *",
      OnbrdContactSecConHeader: "第二联系人",
      OnbrdContactOther: "其他联系人",
      OnbrdContactPrefix: "前缀",
      OnbrdContactTitle: "后缀/职称",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "名字 *",
      OnbrdContactLName: "姓氏 *",
      OnbrdContactPhone: "电话 *",
      OnbrdContactJRole: "工作职责 *",
      job_role_ws: "工作职责",
      OnbrdContactEmail: "电子邮件 *",
      OnbrdContactAddtlType: "类型 *",
      TrngSaveClose: "保存并关闭",
      TrngClose: "关闭",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactFName: "名字",
      OnbrdCertContactLName: "姓氏",
      OnbrdCertContactEmail: "电子邮件",
      ONBCerContactDetails: "认证联系人信息",
      OnbrdThankYouRenewalRegistered:
        "您已提出续订，并将很快收到确认电子邮件。",
      Previous: "上一页",
      "Save and Exit": "保存并退出",
      Submit: "提交",
      Next: "下一页",

      OnbrdContactSectionHeader:
        "请提供贵组织的联系信息。必须提供第一和第二联系人。您可以添加更多联系人，以便我们与您联系探讨销售、营销和技术方面的最新进展。",
      ONBPreferredLanguage: "请选择贵组织的位置及您的首选语言。",
      OnbrdCriteriaBody:
        "感谢您关注APC经销商项目。要想成为会员，您必须首先完成此在线注册。",
      OnbrdCriteriaBody1:
        "请查看期望会员等级的经销商计划要求以及下列注册标准。当您准备开始操作时，请确认您有权完成此次申请。之后，请点击“下一步”继续。",
      OnbrdThankYouNewRegistered:
        "感谢您关注APC经销商项目。您的申请已收悉。您将很快收到确认电子邮件。有关您的申请的任何最新信息，我们将继续通过电子邮件告知您。",
      ONBRegCriteriaAgree: "请查看注册标准并表明您接受该标准。",
      OnbrdTermsSectionHeader: "条款与条件",
      OnbrdThankYouHelpDesk: "如需帮助，请联系APC服务台。",

      Welcome: "欢迎",
      Add_Contacts: "添加联系人",
      add: "添加",
      Select: "选择",
      select_all_that_apply: "选择所有适用的选项",
      i_certify: "我确认本人：",
      tell_us: "向我们介绍贵组织。",
      comp_info_text:
        "请提供有关贵组织的下列信息。如果您希望以后再继续提供信息，则可以使用位于表格底部的按钮保存进度并退出。",
      msg_saving_data: "保存表格数据",
      msg_data_saved: "您的数据已保存。",
      msg_verifing_address: "验证地址",
      basic_comp_info: "基本公司信息",
      location: "地点",
      comp_email_address: "公司电子邮件地址 *",
      save_n_exit_body:
        "您可在准备好完成注册流程后随时返回。下次返回时您将从退出的位置继续。现在您可以关闭浏览器窗口或者导航到其他网站。",
      contact_type: "联系人类型 (选择所有适用的选项) *",
      OnbrdProfileCompType: "公司类型(选择所有适用的选项) * ",
      additional_contacts: "其他联系人",
      add_additional_contacts: "添加其他联系人",
      msg_add_contact_1:
        "在下方添加其他联系人的详细信息。然后，在您完成后单击“保存”",
      confirm_deletion: "确认删除",
      delete_confirm_msg: "您是否确定要删除以下联系人：",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "此流程即将完成。最后一步是阅读合作伙伴联系计划经销商协议。在所示位置确认您接受该协议。",
      Register: "注册",
      "Contact Helpdesk": "联系帮助中心",
      "Continue Enrollment": "继续报名",

      thank_you: "非常感谢。",

      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "经销商须达到期望会员级别的所有标准。请阅读APC经销商项目指南，查看各种要求。",
      reg_ctr_text2: "经销商须完成此项在线注册并接受经销商项目的条款与条件。",
      prog_agmt_checkbox:
        "本人已经阅读、理解并同意遵守此处所示的条款与条件，本人声明并保证自己有权约束该经销商。",
      problem_header: "出现问题。",
      sign_in: "使用 Adobe ID 登录",
      associated_other_account:
        "您登录时使用的 Adobe ID (%{email}) 已与其他 Adobe 合作伙伴计划关联：%{program}。您可以使用其他 Adobe ID 或联系帮助台以继续完成注册流程。",
      account_not_found:
        "您登录时使用的 Adobe ID (%{email}) 与当前任何 Adobe Partner Connection 帐户均不匹配。您可以申请加入 Adobe Partner Connection 计划或使用其他 Adobe ID 登录。",
      OnbrdErrorUnauthorized:
        "抱歉，您无权查看该页面。请联系合作伙伴服务台寻求注册/升级帮助。",
    },
  },

  de_DE: {
    registration: {
      OnbrdContactPrefLang: "Bevorzugte Sprache *",
      ONBLangPref: "Region und Sprache",
      OnbrdCriteriaHeader: "Kriterien f\u00fcr die Anmeldung",
      ONBCompInfo: "Informationen zur Organisation",
      ONBContsInfo: "Kontaktinformationen",
      ONBPgmAgreement: "Programmvereinbarung",
      OnbrdProfileRegion: "Region *",
      OnbrdGenSelectErrorMsg: "Bitte w\u00e4hlen Sie einen Wert.",
      OnbrdProfileCountry: "Land *",
      OnbrdCriteriaSectionHeader: "Kriterien f\u00fcr die Anmeldung",
      OnbrdCriteriaAuthorized:
        "leitender Angestellter oder Mitglied der Gesch\u00e4ftsf\u00fchrung bzw.",
      OnbrdCriteriaAuthorized1:
        "von einem leitenden Angestellten oder Mitglied der Gesch\u00e4ftsf\u00fchrung autorisiert worden, das Anmeldeformular im Namen des Unternehmens auszuf\u00fcllen.",
      ONBEnterCompDetails:
        "Bitte geben Sie folgende Informationen zu Ihrer Organisation an.",
      OnbrdProfileFullCompName: "Vollst\u00e4ndiger Name des Unternehmens *",
      OnbrdProfileTradingName: "Handelsname",
      OnbrdProfileBRN: "Handelsregisternummer *",
      OnbrdProfilePreferredDistributor: "Bevorzugter Distributor",
      OnbrdProfileYrIncorp: "Gr\u00fcndungsjahr *",

      OnbrdProfileStreet: "Stra\u00dfe und Hausnummer *",
      OnbrdProfileCity: "Ort *",
      OnbrdProfileState: "Bundesland *",
      OnbrdProfilePostCode: "PLZ *",
      OnbrdProfilePrimPhone: "Telefon *",
      OnbrdProfilePrimFax: "Fax",
      OnbrdProfileContactEmail: "E-Mail *",
      OnbrdProfilePrimURL: "Website *",
      OnbrdProfileSecondaryURL: "Alternative URL",
      OnbrdProfileListPartnerFinder: "Eintrag im Reseller Finder?",
      OnbrdContactSecContactInfo: "Kontaktinformationen",
      ReAssignContactNameLabel: "Name des Ansprechpartners",
      ConsolePartnerContactEmail: "E-Mail",
      ConsolePartnerContactCType: "Haupt-Ansprechpartnerart",
      OnbrdContactPrimaryType: "Hauptansprechpartner",
      OnbrdContactSecondaryType: "Zweiter Ansprechpartner",
      OnbrdContactOtherType: "Andere",
      ConsolePartnerBtnEdit: "Bearbeiten",
      QBPDelete: "L\u00f6schen",
      OnbrdContactPriConHeader: "Hauptansprechpartner *",
      OnbrdContactSecConHeader: "Zweiter Ansprechpartner",
      OnbrdContactOther: "Weitere Ansprechpartner",
      OnbrdContactPrefix: "Titel",
      OnbrdContactTitle: "Namenszusatz",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Vorname *",
      OnbrdContactLName: "Nachname *",
      OnbrdContactPhone: "Telefon *",
      OnbrdContactJRole: "Position *",
      job_role_ws: "Position",
      OnbrdContactEmail: "E-Mail *",
      OnbrdContactAddtlType: "Funktion *",
      TrngSaveClose: "Speichern und schlie\u00dfen",
      TrngClose: "Schlie\u00dfen",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactFName: "Vorname",
      OnbrdCertContactLName: "Nachname",
      OnbrdCertContactEmail: "E-Mail",
      ONBCerContactDetails:
        "Kontaktinformationen eines zertifizierten Ansprechpartners",
      OnbrdThankYouRenewalRegistered:
        "Ihre Erneuerung wurde angemeldet, und Sie erhalten in K\u00fcrze eine Best\u00e4tigung. Wir halten Sie per E-Mail \u00fcber weitere Aktualisierungen der Erneuerung auf dem Laufenden.",
      Previous: "Zur\u00fcck",
      "Save and Exit": "Speichern und beenden",
      Submit: "Abschicken",
      Next: "Weiter",

      OnbrdContactSectionHeader:
        "HINWEIS: Sie m\u00fcssen einen Hauptansprechpartner und einen zweiten Ansprechpartner angeben. Auf Wunsch k\u00f6nnen Sie Ansprechpartner f\u00fcr technische, vertriebs- und Marketing-relevante Anliegen hinzuf\u00fcgen.",
      ONBPreferredLanguage:
        "Bitte w\u00e4hlen Sie den Standort Ihrer Organisation sowie Ihre bevorzugte Sprache.",
      OnbrdCriteriaBody:
        "Vielen Dank f\u00fcr Ihr Interesse am Adobe Partner Connection Reseller Program. Um am Programm teilzunehmen, m\u00fcssen Sie sich zun\u00e4chst online anmelden. ",
      OnbrdCriteriaBody1:
        "Bitte lesen Sie die im Folgenden beschriebenen Anforderungen f\u00fcr die gew\u00fcnschte Mitgliedsstufe und die Anmeldekriterien sorgf\u00e4ltig durch. Best\u00e4tigen Sie anschlie\u00dfend, dass Sie authorisiert sind, das Anmeldeformular im Namen Ihres Unternehmens auszuf\u00fcllen. Klicken Sie auf \u201eWeiter\u201c, um mit der Anmeldung fortzufahren.",
      OnbrdThankYouNewRegistered:
        "Vielen Dank f\u00fcr Ihre Anmeldung beim Adobe Partner Connection Reseller-Programm. Sie erhalten in K\u00fcrze eine Eingangsbest\u00e4tigung per E-Mail. Wir informieren Sie weiterhin regelm\u00e4\u00dfig \u00fcber den Bearbeitungsstatus Ihres Antrags.",
      ONBRegCriteriaAgree:
        "Bitte lesen und akzeptieren Sie die Anmeldevoraussetzungen.",
      OnbrdTermsSectionHeader: "Bedingungen",
      OnbrdThankYouHelpDesk:
        "Falls Sie Fragen zum Reseller-Programm oder zum Anmeldeprozess haben, wenden Sie sich bitte an den Adobe-Partner Connection Helpdesk.",

      Welcome: "Willkommen",
      Add_Contacts: "Ansprechpartner hinzufügen",
      add: "Hinzufügen",
      Select: "Auswählen",
      select_all_that_apply: "Alle Zutreffenden auswählen",
      i_certify: "Hiermit bestätige ich, dass ich Folgendes bin:",
      tell_us: "Erzählen Sie von Ihrer Organisation.",
      comp_info_text:
        "Bitte geben Sie folgende Informationen zu Ihrer Organisation an. Falls Sie dieses Formular zu einem späteren Zeitpunkt vervollständigen möchten, können Sie über die Schaltfläche unten ihre bisherigen Angaben speichern und den Vorgang beenden.",
      msg_saving_data: "Ihre Formulardaten werden gespeichert",
      msg_data_saved: "Ihre Daten wurden gespeichert.",
      msg_verifing_address: "Adresse wird geprüft",
      basic_comp_info: "Allgemeine Informationen zur Organisation",
      location: "Standort",
      comp_email_address: "E-Mail-Adresse der Organisation *",
      save_n_exit_body:
        "Sie können den Anmeldevorgang jederzeit wiederaufnehmen – genau dort, wo Sie aufgehört haben. Sie können dieses Browser-Fenster jetzt schließen oder zu einer anderen Website wechseln.",
      contact_type: "Art Ansprechpartner (Alle Zutreffenden auswählen) *",
      OnbrdProfileCompType:
        "Art des Unternehmens(Alle Zutreffenden auswählen) * ",
      additional_contacts: "Weitere Ansprechpartner",
      add_additional_contacts: "Weitere Ansprechpartner hinzufügen.",
      msg_add_contact_1:
        "Fügen Sie im Folgenden Details zum weiteren Ansprechpartner hinzu. Wenn Sie fertig sind, klicken Sie auf „Speichern“.",
      confirm_deletion: "Löschen bestätigen",
      delete_confirm_msg: "Möchten Sie ",
      delete_confirm_msg1: "als Ansprechpartner wirklich löschen ?",
      prog_agmt_text:
        "Sie haben es fast geschafft. Lesen Sie zum Abschluss bitte die Partner Connection Program-Vereinbarung für Fachhändler durch. Geben Sie an der entsprechenden Stelle an, dass Sie mit den Bestimmungen einverstanden sind. ",
      Register: "Jetzt registrieren",
      "Contact Helpdesk": "Helpdesk kontaktieren",

      "Continue Enrollment": "Einschreibung",
      thank_you: "Vielen Dank!",
      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "Der Fachhändler erfüllt alle Anforderungen für die gewünschte Mitgliedsstufe. Eine vollständige Übersicht der Anforderungen finden Sie im Leitfaden zum Adobe Partner Connection Reseller Program.",
      reg_ctr_text2:
        "Der Fachhändler füllt das vorliegende Online-Anmeldeformular aus und akzeptiert die Bedingungen des Reseller Program.",
      prog_agmt_checkbox:
        "ICH HABE DIE IM VORLIEGENDEN VERTRAGSTEXT AUFGEFÜHRTEN BESTIMMUNGEN GELESEN, ERKLÄRE MICH MIT IHNEN EINVERSTANDEN UND BESTÄTIGE HIERMIT, DASS ICH AUTORISIERT BIN, DEN FACHHÄNDLER AN DIESEN VERTRAG ZU BINDEN.",
      problem_header: "Ein Problem ist aufgetreten.",
      sign_in: "Mit Adobe ID anmelden",
      associated_other_account:
        "Die Adobe ID, mit der du dich angemeldet hast (%{email}), wird bereits für ein anderes Partnerprogramm von Adobe verwendet: %{program}. Melde dich mit einer anderen Adobe ID an, oder kontaktiere den Helpdesk, um mit deiner Registrierung fortzufahren.",
      account_not_found:
        "Die Adobe ID, mit der du dich angemeldet hast (%{email}), ist keinem aktuellen Adobe Partner Connection-Konto zugeordnet. Du kannst die Teilnahme am Adobe Partner Connection-Programm beantragen oder dich mit einer anderen Adobe ID anmelden.",
      OnbrdErrorUnauthorized:
        "Sie sind nicht berechtigt, diese Seite aufzurufen. Wenn Sie bei der Registrierung bzw. H\u00f6herstufung Hilfe ben\u00f6tigen, wenden Sie sich bitte an den Kundendienst f\u00fcr Adobe-Partner.",
    },
  },

  it_IT: {
    registration: {
      OnbrdContactPrefLang: "Lingua preferita *",
      ONBLangPref: "Area geografica e lingua",
      OnbrdCriteriaHeader: "Criteri di registrazione",
      ONBCompInfo: "Informazioni sull'azienda",
      ONBContsInfo: "Informazioni di contatto",
      ONBPgmAgreement: "Contratto del programma",
      OnbrdProfileRegion: "Area geografica *",
      OnbrdGenSelectErrorMsg: "Selezionare un valore.",
      OnbrdProfileCountry: "Paese *",
      OnbrdCriteriaSectionHeader: "Criteri di registrazione",
      OnbrdCriteriaAuthorized: "responsabile dell'azienda",
      OnbrdCriteriaAuthorized1:
        "persona espressamente autorizzata da un funzionario o dal responsabile a compilare questa domanda per conto dell'azienda.",
      ONBEnterCompDetails:
        "Fornisci le informazioni seguenti sulla tua organizzazione.",
      OnbrdProfileFullCompName: "Nome completo dell’azienda *",
      OnbrdProfileTradingName: "Nome commerciale",
      OnbrdProfileBRN: "Partita IVA *",
      OnbrdProfilePreferredDistributor: "Distributore Preferito",
      OnbrdProfileYrIncorp: "Anno di costituzione *",
      OnbrdProfileStreet: "Via *",
      OnbrdProfileCity: "Località *",
      OnbrdProfileState: "Provincia *",
      OnbrdProfilePostCode: "CAP *",
      OnbrdProfilePrimPhone: "Num. Telefono Principale *",
      OnbrdProfilePrimFax: "Num. Fax Principale",
      OnbrdProfileContactEmail: "E-mail *",
      OnbrdProfilePrimURL: "Sito web *",
      OnbrdProfileSecondaryURL: "Sito web secondario",
      OnbrdProfileListPartnerFinder:
        "Desiderate essere inclusi nell'elenco Reseller Finder?",
      OnbrdContactSecContactInfo: "Informazioni del contatto",
      ReAssignContactNameLabel: "Nome contatto",
      ConsolePartnerContactEmail: "E-mail",
      ConsolePartnerContactCType: "Tipo di contatto principale",
      OnbrdContactPrimaryType: "Principale",
      OnbrdContactSecondaryType: "Secondario",
      OnbrdContactOtherType: "Altro",
      ConsolePartnerBtnEdit: "Modifica",
      QBPDelete: "Elimina",
      OnbrdContactPriConHeader: "Contatto Principale *",
      OnbrdContactSecConHeader: "Contatto Secondario",
      OnbrdContactOther: "Altri contatti",
      OnbrdContactPrefix: "Appellativo",
      OnbrdContactTitle: "Titolo",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Nome *",
      OnbrdContactLName: "Cognome *",
      OnbrdContactPhone: "Telefono *",
      OnbrdContactJRole: "Mansione *",
      job_role_ws: "Mansione",
      OnbrdContactEmail: "E-mail *",
      OnbrdContactAddtlType: "Tipo *",
      TrngSaveClose: "Salva e chiudi",
      TrngClose: "Chiudi",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactFName: "Nome",
      OnbrdCertContactLName: "Cognome",
      OnbrdCertContactEmail: "E-mail",
      ONBCerContactDetails: "Dettagli contatto certificato",
      OnbrdCertContactDeactivated: "DISATTIVA",
      ONBRetailSplQues:
        "Vendita al dettaglio Specializzazione Questionario Programma",
      OnbrdThankYouRenewalRegistered:
        "Il rinnovo è stato archiviato. Riceverete presto un e-mail di conferma. Vi contatteremo via e-mail per qualsiasi aggiornamento relativo al rinnovo.",
      Previous: "Indietro",
      "Save and Exit": "Salva ed esci",
      Submit: "Invia",
      Next: "Avanti",

      OnbrdContactSectionHeader:
        "NOTA: É obbligatorio specificare i contatti principale e secondario. È possibile aggiungere altri contatti che verranno utilizzati per l'invio di aggiornamenti relativi a vendite, marketing e questioni tecniche.",
      ONBPreferredLanguage:
        "Seleziona l'area di appartenenza della tua organizzazione e la lingua preferita.",
      OnbrdCriteriaBody:
        "La ringraziamo per l’interesse verso l’ Adobe Partner Connection Reseller Program. La procedura di adesione inizia con la seguente iscrizione online.",
      OnbrdThankYouHelpDesk:
        "Per eventuali domande sull’Adobe Partner Connection Reseller Program o sulla domanda presentata, contattare l’Adobe Partner Connection Help Desk",
      OnbrdCriteriaBody1:
        "La preghiamo di consultare i requisiti del Reseller Program per il livello desiderato e i criteri di registrazione riportati di seguito. Quando è pronto a procedere, la preghiamo di confermare l'autorizzazione a compilare la presente domanda. Fare clic su Avanti per procedere.",
      OnbrdThankYouNewRegistered:
        "La ringraziamo per l interesse verso l’ Adobe Partner Connection Reseller Program. Abbiamo ricevuto la sua richiesta. A breve riceverà un'e-mail di conferma. La contatteremo per aggiornarla relativamente alla domanda presentata.",
      ONBRegCriteriaAgree:
        "Leggi attentamente i criteri di registrazione e indica che li accetti.",
      OnbrdTermsSectionHeader: "Termini e condizioni",

      Welcome: "Introduzione",
      Add_Contacts: "Aggiungi contatti",
      add: "Aggiungi",
      Select: "Effettua una selezione",
      select_all_that_apply: "Seleziona tutte le risposte applicabili",
      i_certify: "Dichiaro di ricoprire uno di questi due ruoli:",
      tell_us: "Parlaci della tua organizzazione.",
      comp_info_text:
        "Fornisci le informazioni seguenti sulla tua organizzazione. Se preferisci proseguire in un secondo momento, puoi salvare i tuoi progressi e uscire utilizzando il pulsante in fondo al modulo.",
      msg_saving_data: "Salvataggio dei dati del modulo in corso...",
      msg_data_saved: "I tuoi dati sono stati salvati.",
      msg_verifing_address: "Verifica dell'indirizzo in corso...",
      basic_comp_info: "Informazioni di base sull'azienda",
      location: "Sede",
      comp_email_address: "Indirizzo e-mail dell'azienda *",
      save_n_exit_body:
        "Torna in qualsiasi momento per completare il processo di iscrizione. Potrai riprendere la procedura esattamente da dove l’hai interrotta. Ora puoi chiudere questa finestra del browser o navigare su un altro sito web.",
      contact_type:
        "Tipo di contatto (Seleziona tutte le risposte applicabili) *",
      OnbrdProfileCompType:
        "Tipo azienda(Seleziona tutte le risposte applicabili) * ",
      additional_contacts: "Contatti aggiuntivi",
      add_additional_contacts: "Aggiungi un altro contatto",
      msg_add_contact_1:
        "Aggiungi qui sotto i dettagli di un altro contatto. Al termine fai clic su Salva.",
      confirm_deletion: "Conferma cancellazione",
      delete_confirm_msg: "Confermi di voler eliminare il contatto: ",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "Ci siamo quasi. L'ultimo passaggio consiste nel leggere il contratto del programma Rivenditori Adobe Partner Connection. Conferma l'accettazione dove indicato.",
      Register: "Registrati",
      "Contact Helpdesk": "Contatta l'help desk",
      "Continue Enrollment": "iscrizione",

      thank_you: "Grazie.",

      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "Il rivenditore deve soddisfare tutti i criteri del livello desiderato. Per l'elenco completo dei requisiti, consultare la Guida dell’Adobe Partner Connection Reseller Program.",
      reg_ctr_text2:
        "Il rivenditore è tenuto a compilare questa iscrizione online e ad accettare i Termini e le Condizioni del Reseller Program.",
      prog_agmt_checkbox:
        "HO LETTO, COMPRESO E ACCETTATO DI RISPETTARE I TERMINI E LE CONDIZIONI QUI INDICATI E DICHIARO E GARANTISCO DI ESSERE AUTORIZZATO A VINCOLARE IL RIVENDITORE.",
      problem_header: "Si è verificato un problema.",
      sign_in: "Accedi con Adobe ID",
      associated_other_account:
        "L’Adobe ID con cui hai effettuato l'accesso (%{email}) è già associato a un altro programma per i partner Adobe: %{program}. Per continuare la registrazione, prova ad accedere con un altro Adobe ID oppure contatta l'help desk.",
      account_not_found:
        "L’Adobe ID con cui hai effettuato l'accesso (%{email}) non corrisponde ad alcun account corrente di Adobe Partner Connection. Puoi richiedere di aderire al programma Adobe Partner Connection o accedere con un altro Adobe ID.",
      OnbrdErrorUnauthorized:
        "Non si dispone delle autorizzazioni per visualizzare questa pagina. Rivolgersi all'help desk per i partner per ricevere assistenza relativa a registrazione/passaggio a un livello superiore.",
    },
  },

  ja_JP: {
    registration: {
      OnbrdContactPrefLang: "優先される言語 *",
      ONBLangPref: "地域と言語",
      OnbrdCriteriaHeader: "登録の基準",
      ONBCompInfo: "会社情報",
      ONBContsInfo: "連絡先情報",
      ONBPgmAgreement: "プログラム契約",
      OnbrdProfileRegion: "地域 *",
      OnbrdGenSelectErrorMsg: "値を選択してください。",
      OnbrdProfileCountry: "国（半角英数字） *",
      OnbrdCriteriaSectionHeader: "登録の基準",
      OnbrdCriteriaAuthorized: "会社の経営責任者です。",
      OnbrdCriteriaAuthorized1:
        "または、経営責任者からこの登録申請の許可を明示的に受けている人物です。",
      ONBEnterCompDetails: "お客様の組織に関する以下の情報をご記入ください。",
      OnbrdProfileFullCompName: "会社の正式名称  （英語/半角英数字） *",
      OnbrdGenInputErrorMsg: "値を入力してください。",
      OnbrdProfileTradingName: "会社の正式名称  （日本語",
      OnbrdProfileBRN: "法人番号 *",
      OnbrdProfilePreferredDistributor: "発注先パートナー（英語/半角英数字）",
      OnbrdProfileYrIncorp: "創設年 *",
      OnbrdContactPriConHeader: "プライマリ（第一）担当者 *",
      OnbrdProfileStreet: "番地（半角英数字）*",
      OnbrdProfileCity: "市町村（半角英数字）*",
      OnbrdProfileState: "都道府県（半角英数字）*",
      OnbrdProfilePostCode: "郵便番号（半角英数字）*",
      OnbrdProfilePrimPhone: "代表電話番号（半角英数字） *",
      OnbrdProfilePrimFax: "代表ファックス番号（半角英数字）",
      OnbrdProfileContactEmail: "Eメールアドレス（半角英数字）*",
      OnbrdProfilePrimURL: "ウェブサイト（半角英数字）*",
      OnbrdProfileSecondaryURL: "ECウェブサイト（半角英数字）",
      OnbrdProfileListPartnerFinder:
        "リセラーファインダーに掲載希望場合はチェック",
      OnbrdContactSecContactInfo: "担当者情報",
      ReAssignContactNameLabel: "担当社の氏名",
      ConsolePartnerContactEmail: "Eメール",
      ConsolePartnerContactCType: "主担当者タイプ",
      OnbrdContactPrimaryType: "第一",
      OnbrdContactSecondaryType: "第二",
      OnbrdContactOtherType: "その他",
      ConsolePartnerBtnEdit: "編集",
      QBPDelete: "削除",
      OnbrdContactOther: "他の担当者",
      OnbrdContactPrefix: "部署名",
      OnbrdContactTitle: "役職",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "名 (英語) *",
      OnbrdContactLName: "姓（英語）*",
      OnbrdContactPhone: "電話（半角）*",
      OnbrdContactJRole: "役割 *",
      job_role_ws: "役割",
      OnbrdContactEmail: "メール *",
      OnbrdContactAddtlType: "タイプ *",
      TrngSaveClose: "保存して閉じる",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactSectionHeader:
        "ご希望のレベルに達するにはセールストレーニングが必要です。少なくとも1名は「パートナーの行動規範」トレーニングを完了する必要があります。トレーニング要件の一覧については、Adobe Partner Connectionリセラー/リテールプログラムガイドをご覧ください。下のフィールドで、必須トレーニングを完了した人の問い合わせ先を確認できます。",
      OnbrdContactAdd: "担当者の追加",
      OnbrdCertContactFName: "名 (英語)",
      OnbrdCertContactLName: "姓（英語）",
      OnbrdCertContactEmail: "メール",
      OnbrdContactSecConHeader: "セカンダリ（第二）",
      ONBCerContactDetails: "認定担当者の詳細",
      OnbrdThankYouRenewalRegistered:
        "お客様の更新情報が登録されました。　まもなくお客様宛にご確認のメールが送信されます。登録に関する最新情報は別途メールにてお知らせ致します。",
      Previous: "前のページ",
      "Save and Exit": "保存して終了する。",
      Submit: "送信",
      Next: "次へ",
      TrngClose: "閉じる",

      OnbrdContactSectionHeader:
        "組織の担当者情報を入力してください。プライマリ（第一）担当者とセカンダリ（第二）担当者が必要です。その他の担当者を追加していただくとも可能です。",
      ONBPreferredLanguage:
        "お客様の組織の所在地と設定言語を選択してください。",
      OnbrdCriteriaBody:
        "リセラープログラムに、ご興味をお持ちいただき有り難うございます。オンライン登録手続により、メンバーシップを申請できます。",
      OnbrdThankYouHelpDesk:
        "ご質問がある場合、パートナーヘルプデスクまでご連絡ください。",
      OnbrdCriteriaBody1:
        "リセラープログラムのご希望レベルでの必須要件、ならびに、下記の登録基準をご確認ください。 手続の準備が整いましたら、お客様がこの登録を申請する権限を与えられていることを確認してください。",
      OnbrdThankYouNewRegistered:
        "リセラープログラムに、ご興味をお持ちいただき有り難うございます。 お申し込みを受理いたしました。 まもなくお客様宛に、確認のEメールが送信されます。 お申込みに関する最新情報は、引き続きEメールにてお知らせいたします。",
      ONBRegCriteriaAgree: "登録条件を確認し、同意してください。",
      OnbrdTermsSectionHeader: "メンバーシップ規約",

      Welcome: "ようこそ",
      Add_Contacts: "連絡先を追加",
      add: "追加",
      Select: "選択",
      select_all_that_apply: "複数回答可",
      i_certify: "私は、以下の事項を証明します。",
      tell_us: "所属する組織についてお教えください。",
      comp_info_text:
        "お客様の組織に関する以下の情報をご記入ください。後で記入を続けたい場合は、現在の進捗状況を保存して、フォーム下部にあるボタンを使用して終了できます。",
      msg_saving_data: "フォームのデータを保存中",
      msg_data_saved: "データは保存されました。",
      msg_verifing_address: "住所の確認",
      basic_comp_info: "基本会社情報",
      location: "所在地",
      comp_email_address: "会社の電子メールアドレス *",
      save_n_exit_body:
        "登録プロセスを完了する準備ができたらいつでも戻ってきてください。前回終了した時点から再開できます。これでこのブラウザーウィンドウを閉じるか、別のwebサイトに移動できます。",
      contact_type: "連絡先の種類 (複数回答可) *",
      OnbrdProfileCompType: "会社の種類(複数回答可) * ",
      additional_contacts: "その他の連絡先",
      add_additional_contacts: "その他の連絡先を追加",
      msg_add_contact_1:
        "その他の連絡先の詳細を以下に追加してください。次に、完了したら「保存」をクリックしてください。",
      confirm_deletion: "削除を確認",
      delete_confirm_msg: "連絡先「 ",
      delete_confirm_msg1: "」を削除してもよろしいですか？",
      prog_agmt_text:
        "あと少しで完了です。最後にPartner Connectionプログラムの販売代理店契約書をお読みください。該当する箇所で、承諾の意思をご確認ください。",
      Register: "登録",
      "Contact Helpdesk": "ヘルプデスクに連絡",
      "Continue Enrollment": "登録を続ける",

      thank_you: "ありがとうございます。",

      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "リセラー様におかれましては、ご希望されるレベルの必要条件をすべて満たしていただく必要があります。必要条件に関する詳細は、プログラムガイドをご参照ください。",
      reg_ctr_text2:
        "リセラー様は、オンラインエンロールメントを完了し、取引条件及び契約条件にご承諾して頂く必要があります。",
      prog_agmt_checkbox:
        "I HAVE READ, UNDERSTOOD, AND AGREED TO COMPLY WITH THE TERMS AND CONDITIONS INDICATED HEREIN AND REPRESENT AND WARRANT THAT I AM AUTHORIZED TO BIND THE RESELLER.",
      problem_header: "問題が発生しました。",
      sign_in: "Adobe IDでログイン",
      associated_other_account:
        "(%{email})でログインしたAdobe IDは、既に別のアドビパートナープログラム%{program}と関連付けられています。別のAdobe IDでログインするか、ヘルプデスクに連絡して登録を続けることができます。",
      account_not_found:
        "(%{email})でログインしたAdobe IDは、現在のAdobe Partner Connectionアカウントのいずれとも一致しません。Adobe Partner Connectionプログラムへの参加を申請するか、別のAdobe IDでログインできます。",
      OnbrdErrorUnauthorized:
        "申し訳ございません。お客様は、このページを閲覧する権限が与えられておりません。 登録、アップレベルについてヘルプは、パートナーヘルプデスクにお問合せください。",
    },
  },

  ko_KR: {
    registration: {
      OnbrdContactPrefLang: "기본 언어 *",
      ONBLangPref: "지역 및 언어",
      OnbrdCriteriaHeader: "등록 기준",
      ONBCompInfo: "회사 정보",
      ONBContsInfo: "담당자 정보",
      ONBPgmAgreement: "프로그램 계약서",
      OnbrdProfileRegion: "지역 *",
      OnbrdGenSelectErrorMsg: "값을 선택하십시오.",
      OnbrdProfileCountry: "국가 *",
      OnbrdCriteriaSectionHeader: "등록 기준",
      OnbrdCriteriaAuthorized:
        "회사의 최고 경영자 또는 총괄 책임자입니다. 또는 ",
      OnbrdCriteriaAuthorized1:
        "경영진 또는 이사진으로부터 회사를 대표하여 본 신청서를 작성할 수 있는 권한을 위임 받았습니다.",
      OnbrdProfileMembershipId: "멤버십 ID",
      OnbrdProfileFullCompName: "회사 이름(영어) *",
      OnbrdGenInputErrorMsg: "값을 입력하십시오.",
      OnbrdProfileTradingName: "회사 이름(한글)",
      OnbrdProfileBRN: "사업자 등록번호 *",
      OnbrdProfilePreferredDistributor: "선호 총판(영어)",
      OnbrdProfileYrIncorp: "설립 연도 *",
      OnbrdProfileStreet: "주소(영어) *",
      OnbrdProfileCity: "구/군/시(영어) *",
      OnbrdProfileState: "도 *",
      OnbrdProfilePostCode: "우편 번호 *",
      OnbrdProfilePrimPhone: "기본 전화 *",
      OnbrdProfilePrimFax: "기본 팩스 번호",

      OnbrdProfileContactEmail: "이메일 주소 *",
      OnbrdGenEmailFormatErrMsg: "잘못된 이메일 포맷.",
      OnbrdProfileCompanyDomainMsg:
        "귀사가 입력한 회사 이메일 도메인은 기본 담당자의 이메일 도메인과 일치하지 않습니다.",
      OnbrdProfileEmailDomain: "이메일 도메인",
      OnbrdProfilePrimURL: "웹 사이트 *",
      OnbrdProfileSecondaryURL: "추가 웹 사이트",
      OnbrdProfileListPartnerFinder: "리셀러 찾기 목록에 등록하시겠습니까?",
      OnbrdContactSecContactInfo: "담당자 정보",
      ReAssignContactNameLabel: "담당자 이름",
      ConsolePartnerContactEmail: "이메일",
      ConsolePartnerContactCType: "주요 담당자 유형",
      OnbrdContactPrimaryType: "기본",
      OnbrdContactSecondaryType: "추가",
      OnbrdContactOtherType: "기타",
      ConsolePartnerBtnEdit: "수정",
      QBPDelete: "삭제",
      OnbrdContactPriConHeader: "기본 담당자 *",
      OnbrdContactOther: "다른 담당자",
      OnbrdContactPrefix: "경칭",
      OnbrdContactTitle: "호칭/칭호",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "이름 *",
      OnbrdContactLName: "성 *",
      OnbrdContactPhone: "전화 *",
      OnbrdContactJRole: "직무 *",
      OnbrdContactEmail: "이메일 *",
      OnbrdContactAddtlType: "유형 *",
      TrngSaveClose: "저장하고 닫기",
      TrngClose: "닫기",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactFName: "이름",
      OnbrdCertContactLName: "성",
      OnbrdCertContactEmail: "이메일",
      OnbrdPartnerFinderInfoHeader: "등록에 대한 비즈니스 설문 조사",
      ONBAgreeToSubmit: "프로그램 계약서를 검토하고 동의 여부를 선택하십시오.",
      OnbrdThankYouRenewalRegistered:
        "귀사의 갱신 신청서가 제출되었으며 확인 이메일이 곧 전송됩니다.",
      Previous: "이전",
      "Save and Exit": "저장 및 나가기",
      Submit: "제출",
      Next: "다음",
      OnbrdContactSecConHeader: "추가 담당자",
      job_role_ws: "직무",
      OnbrdContactSectionHeader:
        "귀사의 담당자 정보를 제공하십시오. 기본 및 추가 담당자 정보를 모두 입력해야 합니다. Adobe가 세일즈, 마케팅 및 기술 업데이트와 관련하여 귀사에 연락할 수 있도록 담당자를 추가할 수 있습니다.",
      ONBPreferredLanguage: "귀사의 위치와 기본 언어를 선택하십시오.",
      OnbrdCriteriaBody:
        "Adobe Partner Connection Reseller Program에 대한 많은 관심을 보여주셔서 감사합니다. 귀사의 멤버십 가입 과정은 이 온라인 등록 과정부터 시작합니다. ",
      OnbrdThankYouHelpDesk:
        "지원이 필요한 경우 Adobe Partner Connection 헬프 데스크에 문의하십시오.",
      OnbrdCriteriaBody1:
        "아래 원하는 멤버십 등급에 해당하는 Reseller Program 조건과 등록 기준을 검토하십시오. 가입 준비가 모두 완료되면 귀하가 본 신청서를 작성할 수 있는 권한을 가지고 있는지 확인하십시오. 그런 다음 계속하려면 다음을 클릭하십시오.",
      OnbrdThankYouNewRegistered:
        "Adobe Partner Connection Reseller Program에 많은 관심을 보여주셔서 감사합니다. 귀사가 제출한 신청서를 접수했으며 확인 이메일이 곧 전송됩니다. 귀사의 신청서와 관련하여 업데이트된 사항이 있으면 이메일을 통해 통보해 드리겠습니다.",
      ONBRegCriteriaAgree: "등록 기준을 검토하고 동의 여부를 선택하십시오.",
      OnbrdTermsSectionHeader: "약관",

      Welcome: "환영합니다",
      Add_Contacts: "연락처 추가",
      add: "추가",
      Select: "선택",
      select_all_that_apply: "해당 사항을 모두 선택하십시오",
      i_certify: "다음 중 하나임을 증명합니다.",
      tell_us: "회사 정보",
      comp_info_text:
        "귀사에 대한 다음 정보를 제공하십시오. 나중에 계속하려면 작성한 내용을 저장한 후 양식 하단에 있는 버튼을 사용하여 종료하십시오.",
      msg_saving_data: "양식 데이터 저장 중",
      msg_data_saved: "데이터가 저장되었습니다.",
      msg_verifing_address: "주소 확인 중",
      basic_comp_info: "기본 회사 정보",
      location: "위치",
      comp_email_address: "회사 이메일 주소 *",
      save_n_exit_body:
        "등록 절차를 완료할 준비가 되면 언제든지 중단한 지점부터 다시 시작할 수 있습니다. 이 브라우저 창을 닫거나 다른 웹 사이트로 이동하십시오.",
      contact_type: "연락처 유형 (해당 사항을 모두 선택하십시오) *",
      OnbrdProfileCompType: "회사 유형 (해당 사항을 모두 선택하십시오) * ",
      additional_contacts: "추가 연락처",
      add_additional_contacts: "연락처 추가",
      msg_add_contact_1:
        "아래에 추가 연락처의 세부 정보를 입력한 후 완료되면 저장을 클릭하십시오.",
      confirm_deletion: "삭제 확인",
      delete_confirm_msg: " ",
      delete_confirm_msg1: " 연락처를 삭제하시겠습니까?",
      prog_agmt_text:
        "거의 다 되었습니다. 마지막으로 Partner Connection Program 리셀러 계약서를 읽은 후 표시된 부분에서 수락 여부를 확인하십시오.",
      Register: "등록",
      "Contact Helpdesk": "헬프데스크에 문의",
      //correct job role take from new translation once availabe
      "Continue Enrollment": "계속 등록",

      thank_you: "감사합니다.",

      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "리셀러는 업그레이드하려는 등급의 모든 기준을 충족해야 합니다. 자격 조건에 대한 자세한 내용은 Adobe Partner Connection Reseller Program Guide를 참조하십시오.",
      reg_ctr_text2:
        "리셀러는 이 온라인 양식을 작성하고 리셀러 프로그램 약관에 동의해야 합니다.",
      prog_agmt_checkbox:
        "본 문서에 명시된 약관을 읽고 이해했으며 이 약관을 준수할 것에 동의합니다. 그리고 리셀러를 구속할 수 있는 권한을 부여 받았음을 진술하고 보장합니다.",
      problem_header: "문제가 발생했습니다.",
      sign_in: "Adobe ID로 로그인",
      associated_other_account:
        "(%{email})(으)로 로그인한 Adobe ID가 이미 다른 Adobe 파트너 프로그램, %{program}과(와) 연결되어 있습니다. 다른 Adobe ID로 로그인하거나 헬프데스크에 문의하여 등록을 계속할 수 있습니다.",
      account_not_found:
        "(%{email})(으)로 로그인한 Adobe ID가 현재 Adobe Partner Connection 계정과 일치하지 않습니다. Adobe Partner Connection 프로그램 등록을 신청하거나 다른 Adobe ID로 로그인할 수 있습니다.",
      OnbrdErrorUnauthorized:
        "죄송합니다. 이 페이지를 볼 수 있는 권한이 없습니다. 등록/등급 상승에 대한 자세한 내용은 파트너 헬프 데스크에 문의하십시오.",
    },
  },

  es_ES: {
    registration: {
      OnbrdContactPrefLang: "Idioma preferido *",
      ONBLangPref: "Región e idioma",
      OnbrdCriteriaHeader: "Requisitos de inscripción",
      ONBCompInfo: "Información de la empresa",
      ONBContsInfo: "Información de contacto",
      ONBPgmAgreement: "Acuerdo del programa",
      OnbrdProfileRegion: "Región *",
      OnbrdGenSelectErrorMsg: "Seleccione un valor.",
      OnbrdProfileCountry: "País *",
      OnbrdCriteriaSectionHeader: "Requisitos de inscripción",
      OnbrdCriteriaAuthorized: "responsable o director de la empresa ",
      OnbrdCriteriaAuthorized1:
        "la persona autorizada expresamente por el responsable o director para completar esta solicitud en nombre de la empresa.",
      ONBEnterCompDetails:
        "Por favor, proporciona la siguiente información sobre tu empresa.",
      OnbrdProfileFullCompName: "Nombre de la Empresa *",
      OnbrdProfileTradingName: "Nombre comercial",
      OnbrdProfileBRN: "Número de Identificación Fiscal *",
      OnbrdProfilePreferredDistributor: "Mayorista Preferido",
      OnbrdProfileYrIncorp: "Año de creación *",
      OnbrdProfileStreet: "Calle *",
      OnbrdProfileCity: "Ciudad *",
      OnbrdProfileState: "Estado/Provincia *",
      OnbrdProfilePostCode: "Código postal *",
      OnbrdProfilePrimPhone: "Teléfono principal *",
      OnbrdProfilePrimFax: "Fax",
      OnbrdProfileContactEmail: "Correo electrónico *",
      OnbrdProfilePrimURL: "Sitio web *",
      OnbrdProfileSecondaryURL: "Sitio web secundario",
      OnbrdProfileListPartnerFinder:
        "¿Desea que se le añada a la lista del buscador de revendedores?",
      OnbrdContactSecContactInfo: "Datos de contacto",
      ReAssignContactNameLabel: "Nombre de contacto",
      ConsolePartnerContactEmail: "Correo electrónico",
      ConsolePartnerContactCType: "Tipo de contacto principal",
      OnbrdContactPrimaryType: "Principal",
      OnbrdContactSecondaryType: "Secundario",
      OnbrdContactOtherType: "Otros",
      ConsolePartnerBtnEdit: "Editar",
      QBPDelete: "Eliminar",
      job_role_ws: "Funciones del puesto",
      OnbrdContactPriConHeader: "Contacto Principal *",
      OnbrdContactSecConHeader: "Contacto secundario",
      OnbrdContactOther: "Otros contactos",
      OnbrdContactPrefix: "Título (antepuesto al nombre)",
      OnbrdContactTitle: "Título (pospuesto al nombre)/puesto de trabajo",
      prefixMaxLengthError:
        "Prefix must be 10 characters or fewer, Kindly update.",
      suffixMaxLengthError:
        "Suffix must be 10 characters or fewer, Kindly update.",
      OnbrdContactFName: "Nombre *",
      OnbrdContactLName: "Apellido *",
      OnbrdContactPhone: "Teléfono *",
      OnbrdContactJRole: "Funciones del puesto *",
      OnbrdContactEmail: "Correo electrónico *",
      OnbrdContactAddtlType: "Tipo *",
      TrngSaveClose: "Guardar y cerrar",
      TrngClose: "Cerrar",
      ONBRegCerContacts:
        "Please select and complete the required COC training course before submitting your request.",
      OnbrdCertContactFName: "Nombre",
      OnbrdCertContactLName: "Apellido",
      OnbrdCertContactEmail: "Correo electrónico",
      ONBCerContactDetails: "Detalles de contacto certificados",
      OnbrdCertContactDeactivated: "DESACTIVAR",
      OnbrdThankYouRenewalRegistered:
        "Se ha archivado su renovación y en breve recibirá un correo electrónico de confirmación. Le informaremos a través del correo electrónico sobre cualquier actualización relativa a su renovación.",
      Previous: "Anterior",
      "Save and Exit": "Guardar y salir",
      Submit: "Enviar",
      Next: "Siguiente",

      OnbrdContactSectionHeader:
        "NOTA: Se requieren contactos primarios y secundarios. Puede que desee añadir contactos adicionales para que nos pongamos en contacto con usted para fines comerciales, de marketing y de actualizaciones técnicas.",
      ONBPreferredLanguage:
        "Por favor, selecciona la ubicación de tu empresa y el idioma deseado.",
      OnbrdCriteriaBody:
        "Le agradecemos el interés mostrado en el Programa de Adobe Partner Connection Reseller Program. El camino que debe seguir para inscribirse comienza con este proceso de inscripción en línea. ",
      OnbrdCriteriaBody1:
        "Revise los requisitos del Reseller Program para el nivel deseado así como los requisitos de inscripción que se muestran a continuación. Cuando esté listo para continuar, confirme que está autorizado para completar esta solicitud. Después, haga clic en Siguiente para continuar.",
      OnbrdThankYouNewRegistered:
        "Le agradecemos su interés mostrado en el Adobe Partner Connection Reseller Program. Hemos recibido su solicitud. En breve recibirá un correo electrónico de confirmación. Le informaremos a través del correo electrónico sobre cualquier actualización relativa a su solicitud.",
      ONBRegCriteriaAgree:
        "Por favor, revisa los requisitos de inscripción e indica tu aceptación.",
      OnbrdTermsSectionHeader: "Términos y condiciones",
      OnbrdThankYouHelpDesk:
        "Si tiene cualquier pregunta sobre el Adobe Partner Connection Reseller Program, póngase en contacto con el servicio de asistencia Adobe Partner Connection Help Desk",

      Welcome: "Bienvenido",
      Add_Contacts: "Agregar contactos",
      add: "Agregar",
      Select: "Seleccionar",
      select_all_that_apply: "Seleccionar todas las opciones aplicables",
      i_certify: "Certifico que soy:",
      tell_us: "Háblanos de tu empresa.",
      comp_info_text:
        "Por favor, proporciona la siguiente información sobre tu empresa. Si prefieres continuar más tarde, puedes guardar tu progreso y salir mediante el botón situado al final del formulario.",
      msg_saving_data: "Guardando los datos del formulario.",
      msg_data_saved: "Se han guardado los datos.",
      msg_verifing_address: "Verificando dirección",
      basic_comp_info: "Información básica de la empresa",
      location: "Ubicación",
      comp_email_address: "Dirección de correo electrónico de la empresa *",
      save_n_exit_body:
        "Vuelve cuando quieras completar el proceso de inscripción. Volverás al lugar en el que lo dejaste. Ahora puedes cerrar esta ventana del explorador o navegar a otro sitio web.",
      contact_type:
        "Tipo de contacto (Seleccionar todas las opciones aplicables) *",
      OnbrdProfileCompType:
        "Tipo de empresa(Seleccionar todas las opciones aplicables) * ",
      additional_contacts: "Contactos adicionales",
      add_additional_contacts: "Agregar contacto adicional",
      msg_add_contact_1:
        "Añade los detalles del contacto adicional abajo. Cuando hayas terminado, haz clic en Guardar",
      confirm_deletion: "Confirmar eliminación",
      delete_confirm_msg: "¿Estás seguro de que deseas eliminar el contacto: ",
      delete_confirm_msg1: "?",
      prog_agmt_text:
        "Casi hemos acabado. El último paso consiste en leer el acuerdo de distribuidor Partner Connection Program. Confirma tu aceptación donde se indica.",
      Register: "Regístrate",
      "Contact Helpdesk": "Contactar con el servicio de asistencia",
      "Continue Enrollment": "Continuar la inscripción",

      thank_you: "Gracias.",

      Return_to_Adobe_Channel_Partners: "Adobe Partner Connection",

      reg_ctr_text1:
        "Los revendedores deben cumplir todos los requisitos para el nivel deseado. Consulte la Guía del Adobe Partner Connection Reseller Program para obtener una lista completa de los requisitos.",
      reg_ctr_text2:
        "Los revendedores deben completar esta inscripción en línea y aceptar los términos y condiciones del Reseller Program.",
      prog_agmt_checkbox:
        "HE LEÍDO, COMPRENDO Y ACEPTO CUMPLIR LOS TÉRMINOS Y CONDICIONES AQUÍ ESTIPULADOS, Y DECLARO Y GARANTIZO QUE ESTOY AUTORIZADO A VINCULAR AL REVENDEDOR.",
      problem_header: "Ha habido un problema.",
      sign_in: "Iniciar sesión con Adobe ID",
      associated_other_account:
        "El Adobe ID con el que has iniciado sesión (%{email}) ya está asociado con otro programa de socios de Adobe: %{program}. Puedes iniciar sesión con otro Adobe ID o ponerte en contacto con el servicio de asistencia para continuar con tu registro.",
      account_not_found:
        "El Adobe ID con el que has iniciado sesión (%{email}) no coincide con ninguna cuenta actual de Adobe Partner Connection. Puedes solicitar unirte al programa de Adobe Partner Connection o iniciar sesión con un Adobe ID diferente.",
      OnbrdErrorUnauthorized:
        "No está autorizado para ver esta página. Póngase en contacto con el servicio de asistencia de socios para recibir ayuda relativa al registro o la actualización.",
    },
  },

  es_LA: {
    registration: {},
  },
};

export default regTranslation;
